import { Dialog, Loading } from '@koopajs/mui';
import { useResourceShow } from '@koopajs/react';
import { MeetingReviewForDialog } from 'components/Meetings/MeetingReviewForDialog';
import { IMeeting } from 'types';

interface IMinutesPreviewDialogProps {
  meetingId: string;
  isOpen: boolean;
  onClose: (() => Promise<void>) | (() => void);
}

export const MinutesPreviewDialog: React.FC<IMinutesPreviewDialogProps> = (props) => {
  const keyPrefix = 'Dialogs.MinutesPreviewDialog.DialogView';

  const { meetingId, isOpen, onClose } = props;
  const { resource: minutes } = useResourceShow<IMeeting>({
    path: '/meetings',
    id: meetingId
  });

  return (
    <Dialog.View isCloseVisible={true} isOpen={isOpen} onClose={onClose} i18n={{ keyPrefix }}>
      {minutes ? (
        <MeetingReviewForDialog meeting={minutes} isBeingReviewedInsideMeeting={false} isViewMode={true} />
      ) : (
        <Loading sx={{ backgroundColor: 'transparent' }} />
      )}
    </Dialog.View>
  );
};
